<template>
  <div>
    <v-card>
      <v-toolbar flat color="white">
        <v-toolbar-title>
          <v-icon class="mb-1">mdi-web</v-icon>
          AGENTES DE CARGA
        </v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Buscar"
          single-line
          class="mt-5"
        ></v-text-field>
        <v-checkbox
          v-model="incluirInactivos"
          label="Incluir inactivos"
          dense
          class="mt-2 ml-2"
          @change="cargarLista"
        ></v-checkbox>
        <v-spacer></v-spacer>
        <v-btn small color="primary" @click="abrirFormAgente(null)">
          <v-icon>mdi-plus-circle-outline</v-icon> Nuevo agente
        </v-btn>
      </v-toolbar>
      <v-data-table
        :headers="headers"
        :items="lista"
        :items-per-page="itemsPerPage"
        :search="search"
        :loading="loadingTable"
        class="elevation-1"
      >
        <template v-slot:item.opcion="{ item }">
          <v-btn icon color="green" @click="abrirFormAgente(item.AGT_ID)">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>

          <v-btn icon color="red" @click="eliminarAgente(item.AGT_ID)">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </template>

        <template v-slot:item.description="{ item }">
          <v-btn
            icon
            small
            color="red"
            target="_blank"
            @click="editarGrupoPermisos(item.AGT_ID, item.description)"
          >
            <v-icon color="#119800">mdi-square-edit-outline</v-icon>
          </v-btn>
          {{ item.description }}
        </template>
      </v-data-table>
    </v-card>

    <v-dialog v-model="formAgente" persistent max-width="500px" >
      <v-card>
        <v-toolbar dark  flat height="40" color="blue">
          <v-toolbar-title >
            Agente de carga
          </v-toolbar-title>
          <v-spacer>
            
          </v-spacer>
          <v-btn icon @click="formAgente = !formAgente">
            <v-icon >
              mdi-close
            </v-icon>
          </v-btn>
          
        </v-toolbar>
        
        <v-card-text>
          <v-container>
            <v-form ref="formAgente">
              <v-row class="mt-0 mb-0">
                <v-col class="pt-0 pb-0" cols="12">
                  <v-text-field
                    v-model="agtId"
                    label="Codigo"
                    :disabled="agEdit"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row class="mt-0 mb-0">
                <v-col class="pt-0 pb-0" cols="12">
                  <v-text-field
                    v-model="agtNombre"
                    label="Nombre "
                    :rules="requiredRule"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
              
              <v-row class="mt-0 mb-0">
                <v-col class="pt-0 pb-0" cols="6">
                  <v-text-field
                    v-model="agtIata"
                    label="Código IATA"
                    :rules="requiredRule"
                  >
                  </v-text-field>
                </v-col>
              
                <v-col class="pt-0 pb-0" cols="6">
                  <v-text-field
                    v-model="agtRuc"
                    label="RUC"
                    :rules="requiredRule"
                  >
                  </v-text-field>
                </v-col>                              
              </v-row>
              <v-row class="mt-0 mb-0">
                <v-col class="pt-0 pb-0" cols="6">
                  <v-text-field v-model="agtCiudad" label="Ciudad">
                  </v-text-field>
                </v-col>
                <v-col class="pt-0 pb-0" cols="6">
                  <v-text-field v-model="agtPais" label="País">
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row class="mt-0 mb-0">
                <v-col class="pt-0 pb-0" cols="12">
                  <v-text-field v-model="agtDir" label="Dirección">
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row class="mt-0 mb-0">
                <v-col class="pt-0 pb-0" cols="12">
                  <v-text-field v-model="agtTel" label="Teléfono">
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row class="mt-0 mb-0">
                <v-col class="pt-0 pb-0" cols="12">
                  <v-switch v-model="agtActivo" label="Activo"></v-switch>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-col class="text-center">
            <v-btn small color="primary" @click="guardarAgente">
              <v-icon>mdi-content-save</v-icon> Guardar
            </v-btn>
            &nbsp;&nbsp;
            <v-btn small @click="formAgente = !formAgente">
              <v-icon>mdi-cancel</v-icon> Cancelar
            </v-btn>
          </v-col>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
import Vue from "vue";

export default {
  name: "AgenteComponent",
  data: () => ({
    headers: [
      { text: "Opciones", value: "opcion" },
      { text: "Codigo", value: "AGT_ID" },
      { text: "Nombre", value: "AGT_NOMBRE" },
      { text: "Ciudad", value: "AGT_CIUDAD" },
      { text: "País", value: "AGT_PAIS" },
      { text: "Teléfono", value: "AGT_TEL" },
    ],

    requiredRule: [(v) => !!v || "El campo es requerido"],
    lista: [],
    options: {},
    dialog: false,
    notifications: false,
    sound: true,
    widgets: true,

    search: null,

    incluirInactivos: false,

    agEdit: false,
    formAgente: false,
    agtId: "",
    agtNombre: "",
    agtCiudad: "",
    agtPais: "",
    agtIata: "",
    agtRuc: "",
    agtDir: "",
    agtTel: "",
    agtActivo: true,

    itemsPerPage: 20,
    searchGroupId: "",
    searchNombreGrupo: "",
  }),
  computed: {
    ...mapState("master", ["loadingTable", "user"]),

    ...mapGetters("access", ["btnAbrirCaja"]),
  },
  methods: {
    ...mapMutations("master", [
      "setUrl",
      "setOverlay",
      "setMenu",
      "setLoadingTable",
      "setTitleToolbar",
    ]),

    ...mapActions("master", ["requestApi", "alertNotification"]),

    guardarAgente() {
      if (!this.$refs.formAgente.validate()) {
        return;
      }
      if (this.agEdit == false) {
        this.setUrl("api/agentes");
        this.requestApi({
          method: "POST",
          data: {
            AGT_ID: this.agtId,
            AGT_NOMBRE: this.agtNombre,
            AGT_CIUDAD: this.agtCiudad,
            AGT_PAIS: this.agtPais,
            AGT_IATA_CODE: this.agtIata,
            AGT_RUC: this.agtRuc,
            AGT_DIR: this.agtDir,
            AGT_TEL: this.agtTel,
            ACTIVO: this.agtActivo,
          },
        })
          .then((res) => {
            console.log(res);
            this.cargarLista();
          })
          .catch(() => {})
          .then(() => {
            this.formAgente = false;
          });
      }
      if (this.agEdit == true) {
        this.setUrl("api/agentes/" + this.agtId);
        this.requestApi({
          method: "PUT",
          data: {
            AGT_NOMBRE: this.agtNombre,
            AGT_CIUDAD: this.agtCiudad,
            AGT_PAIS: this.agtPais,
            AGT_IATA_CODE: this.agtIata,
            AGT_RUC: this.agtRuc,
            AGT_DIR: this.agtDir,
            AGT_TEL: this.agtTel,
            ACTIVO: this.agtActivo,
          },
        })
          .then((res) => {
            console.log(res);
            this.cargarLista();
          })
          .catch(() => {})
          .then(() => {
            this.formAgente = false;
          });
      }
    },

    cargarLista() {
      this.setLoadingTable(true);
      this.setUrl("api/agentes");
      this.requestApi({
        method: "GET",
        data: { activo: this.incluirInactivos ? null : 1 },
      })
        .then((res) => {
          console.log(res);
          this.lista = res.data;
          this.pageCount = 10;
        })
        .catch(() => {})
        .then(() => {
          this.setLoadingTable(false);
        });
    },
    //crearAgente(sgid) {},
    abrirFormAgente(agid) {
      if (agid == null) {
        this.agEdit = false;
        this.agtActivo = true;
      } else {
        this.agEdit = true;
      }
      this.setUrl("api/agente/" + agid);
      this.requestApi({
        method: "GET",
        data: {},
      })
        .then((res) => {
          console.log(res.data);

          this.agtId = agid;
          this.agtNombre = res.data.AGT_NOMBRE;
          this.agtCiudad = res.data.AGT_CIUDAD;
          this.agtPais = res.data.AGT_PAIS;
          this.agtIata = res.data.AGT_IATA_CODE;
          this.agtRuc = res.data.AGT_RUC;
          this.agtDir = res.data.AGT_DIR;
          this.agtTel = res.data.AGT_TEL;
          this.agtActivo = res.data.ACTIVO;
          this.formAgente = true;
        })
        .then(() => {});
    },

    eliminarAgente(agenteId) {
      Vue.swal({
        html: "Está seguro de eliminar el agente?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cerrar",
        ...this.paramAlertQuestion,
      }).then((result) => {
        if (result.isConfirmed) {
          this.setUrl("api/agente");
          this.requestApi({
            method: "DELETE",
            data: {
              AGT_ID: agenteId,
            },
          }).then((res) => {
            console.log(res);
            this.alertNotification({ param: { html: res.data.msg } });
            this.cargarLista();
          });
        }
      });
    },
  },
  mounted() {
    this.cargarLista();
    this.setTitleToolbar("Agentes de carga");
    document.title = "Sistema de carga";
  },
};
</script>
